"use client";

import { FcGoogle } from "react-icons/fc";
import { FaLine } from "react-icons/fa6";
import { MdLogout } from "react-icons/md";
import { logoGreen, Mascotte, LoginImg } from "../assets";
import Image from "next/image";
import type { AuthStatus, AuthUser } from "../hooks/useAuth";

type LoginProps = {
    mode?: "inline" | "fullscreen";
    status: AuthStatus;
    user: AuthUser | null;
    onLogin?: () => void | Promise<void>;
    onLogout?: () => void | Promise<void>;
    onBackToMainLogin?: () => void;
};

export default function TeacherLogin({ mode = "inline", status, user, onLogin, onLogout, onBackToMainLogin }: LoginProps) {
    const displayUser = user;

    if (mode === "fullscreen") {
        return (
            <div className="min-h-screen bg-[#F4F3ED] flex items-center justify-center">
                <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] flex flex-col md:flex-row w-full max-w-4xl overflow-hidden min-h-[700px]">

                    <div className="relative w-full md:w-1/2 hidden md:block">
                        <Image
                            src={LoginImg}
                            alt="THAI PILA Illustration"
                            fill
                            className="object-cover"
                            priority
                        />
                    </div>


                    <div className="w-full md:w-1/2 p-8 md:p-4 flex flex-col items-center justify-center">

                        <h1 className="text-2xl font-bold text-gray-900 mb-8">
                            Teacher Login
                        </h1>

                        <div className="flex flex-col">
                            <div className="flex flex-col gap-4">

                                <button
                                    type="button"
                                    onClick={() => {
                                        void onLogin?.();
                                    }}
                                    className="flex w-full cursor-pointer items-center justify-start gap-4 bg-white px-12 py-3 text-sm font-medium text-neutral-700 shadow-[0_2px_8px_rgba(0,0,0,0.12)] transition hover:bg-neutral-50 rounded-md"
                                >
                                    <FcGoogle size={24} />
                                    <span className="text-lg font-medium">เข้าสู่ระบบด้วย Google</span>
                                </button>

                                <button
                                    type="button"
                                    // onClick={() => {
                                    //     void onLogin?.();
                                    // }}
                                    className="flex w-full cursor-pointer items-center justify-start gap-4 bg-white px-12 py-3 text-sm font-medium text-neutral-700 shadow-[0_2px_8px_rgba(0,0,0,0.12)] transition hover:bg-neutral-50 rounded-md"
                                >
                                    <FaLine size={24} color="#06C755" />
                                    <span className="text-lg font-medium">เข้าสู่ระบบด้วย Line</span>
                                </button>

                            </div>
                        </div>

                        <div className="text-center text-black pt-1 sm:pt-2">
                            <div className="mt-8 sm:mt-10">
                                <p className="text-base mb-1">สร้างบัญชีหรือเข้าสู่ระบบด้วยบริการที่คุณใช้ในโรงเรียนของคุณ</p>
                                <p className="text-base mb-1">หากบริการที่คุณใช้ปกติไม่อยู่ในตัวเลือก</p>
                                <p className="text-base">กรุณาขอให้ครูของคุณติดต่อ edu.pila@oecd.org</p>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={onBackToMainLogin}
                            className="mt-8 w-fit px-6 py-2 bg-[#FCE654] hover:bg-[#F5DF4D] text-gray-900 hover:text-black text-sm font-medium rounded-md shadow-sm transition-all duration-200 ease-in-out cursor-pointer active:scale-[0.98]"
                        >
                            กลับไปหน้าเลือก Login
                        </button>

                    </div>
                </div>
            </div>
        );
    }

    if (status === "checking") {
        return (
            <div className="rounded-md border border-neutral-200 px-3 py-2 text-sm text-neutral-500">
                Loading account...
            </div>
        );
    }

    if (!displayUser) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 rounded-md px-2 py-1">
            <div className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-rose-200 text-rose-700 font-bold">
                {displayUser.picture ? (
                    <img
                        src={displayUser.picture}
                        alt={displayUser.name ?? "User avatar"}
                        className="h-full w-full object-cover"
                    />
                ) : (
                    <span>{(displayUser.name || displayUser.role || "A").charAt(0).toUpperCase()}</span>
                )}
            </div>
            <span className="hidden max-w-42 truncate text-base sm:inline mr-4">
                {displayUser.name ?? displayUser.role ?? displayUser.email ?? (displayUser.id ? `User ID: ${displayUser.id.substring(0, 8)}...` : "")}
            </span>
            <button
                type="button"
                onClick={() => {
                    void onLogout?.();
                }}
                className="cursor-pointer text-neutral-700 hover:text-neutral-900"
                aria-label="Sign out"
                title="Sign out"
            >
                <MdLogout size={20} />
            </button>
        </div>
    );
}